import { Calculate, QuestionAnswer } from "@mui/icons-material";

export const psyEvaluationsTabs = [
	{
		icon: <Calculate />,
		entity: "detail",
		label: "Cotação",
	},
	{
		icon: <QuestionAnswer />,
		entity: "responses",
		label: "Respostas",
	},
];
